
import { useState } from 'react';

import { useSelector } from 'react-redux';

import { Link } from 'react-router';

import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';

import { FaSearch } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";
import { FaBook } from "react-icons/fa";

import { RootState } from '../../store';

import { ListItembuttonStyle, ListItemIconStyle, ListItemTextStyle, ListTypographyStyle, MenuItemStyle, TypographyAppBarStyle } from '../../styles/ListItemStyle';

export const ListItemConsultas = () => {

    const { roles } = useSelector( ( state: RootState ) => state.auth );

    const [anchorEl, anchorElOpen] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpen = ( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
        anchorElOpen( e.currentTarget );
    };
    
    const handleClose = () => {
        anchorElOpen( null );
    };

    return (
        <>
        
            <ListItemText style={ ListItemTextStyle }>
        
                <Button color="inherit" style={ ListItembuttonStyle } onClick={ handleOpen }>

                    <FaSearch style={ ListItemIconStyle } />

                    <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                        Consultas
                    </Typography>     
                    
                    <FaChevronDown style={ ListItemIconStyle } />  

                </Button>

            </ListItemText>

            <Menu 
                elevation={ 2 } 
                anchorEl={ anchorEl } 
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} 
                keepMounted open={ open } 
                onClose={ handleClose }
            >

                {
                    roles?.VisualizadorExpedienteVirtual
                    && 
                        <Link to="/consultas/expediente-virtual" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaBook /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Expediente Virtual</ListItemText>
                            </MenuItem>
                        </Link>
                }

                {
                    roles?.VisualizadorConsultaAudiencias 
                    && 
                        <Link to="/consultas/agenda-audiencias" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Agenda de audiencias</ListItemText>
                            </MenuItem>
                        </Link>
                }

                {
                    roles?.VisualizadorConsultaTramitesRecibidos 
                    && 
                        <Link to="/consultas/tramites-recibidos" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Trámites recibidos</ListItemText>
                            </MenuItem>
                        </Link>
                }

                {
                    roles?.VisualizadorConsultaAcuerdos 
                    && 
                        <Link to="/consultas/acuerdos-pendientes" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Acuerdos pendientes</ListItemText>
                            </MenuItem>
                        </Link>
                }

                {
                    roles?.VisualizadorConsultaOficios 
                    && 
                        <Link to="/consultas/oficios" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Oficios</ListItemText>
                            </MenuItem>
                        </Link>
                }

                {
                    roles?.VisualizadorConsultaExhortosLibrados 
                    && 
                        <Link to="/consultas/exhortos-librados" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Exhortos librados</ListItemText>
                            </MenuItem>
                        </Link>
                }

                {
                    roles?.VisualizadorConsultaNotificaciones 
                    && 
                        <Link to="/consultas/notificaciones" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Notificaciones</ListItemText>
                            </MenuItem>
                        </Link>
                }      

                {
                    roles?.VisualizadorConsultaExpedientesPorEtapaProcesal 
                    && 
                        <Link to="/consultas/expedientes-por-etapa-procesal" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Expedientes por etapa procesal</ListItemText>
                            </MenuItem>
                        </Link>
                }               

                {
                    roles?.VisualizadorConsultaIncidentes 
                    && 
                        <Link to="/consultas/incidentes" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Incidentes</ListItemText>
                            </MenuItem>
                        </Link>
                }  

                {
                    roles?.VisualizadorConsultaCertificaciones 
                    && 
                        <Link to="/consultas/certificaciones" style={{ textDecoration: 'none' }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose } > 
                                <ListItemIcon> <FaSearch /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Certificaciones</ListItemText>
                            </MenuItem>
                        </Link>
                }  

            </Menu>
        
        </>        
    )
}